import { z } from "zod";
import { addressSchema, envelope, launchChain, launchRequest } from "./launchpad";
import { launchContracts } from "../contracts/launchpad";

export const launchConfig = envelope(z.object({
  chainId: z.literal(launchChain), nativeSymbol: z.literal("HYPE"),
  launchpadAddress: addressSchema, liquidityLockerAddress: addressSchema,
  sniperHookAddress: addressSchema, poolManagerAddress: addressSchema,
  v4PoolFeePct: z.literal(1),
  antiSniper: z.object({ enabled: z.literal(true), startFeePct: z.literal(99), decayDurationSeconds: z.literal(10),
    creatorExempt: z.literal(true), maxAdditionalExemptWallets: z.literal(10),
    decayFeeCreatorSharePct: z.literal(50), decayFeeProtocolSharePct: z.literal(50) }),
}));

export async function verifyLaunchConfig(signal?: AbortSignal) {
  const { data } = await launchRequest("/config", launchConfig, {
    signal: signal ? AbortSignal.any([signal, AbortSignal.timeout(15000)]) : AbortSignal.timeout(15000),
  });
  if (data.launchpadAddress.toLowerCase() !== launchContracts.launchpad ||
      data.liquidityLockerAddress.toLowerCase() !== launchContracts.locker ||
      data.sniperHookAddress.toLowerCase() !== launchContracts.sniperHook ||
      data.poolManagerAddress.toLowerCase() !== "0xe2e105d3f7209a9da11f83ccf3e7398a753823f1") {
    throw new Error("Deployment mismatch. Refresh the application before sending a transaction.");
  }
  return data;
}
